import React from 'react';

interface NavItem {
  label: string;
  icon: string;
  active?: boolean;
  badge?: number;
}

const NAV_ITEMS: NavItem[] = [
  { label: 'Chat', icon: 'chat', active: true },
  { label: 'Clientes', icon: 'users' },
  { label: 'Ordens', icon: 'clipboard', badge: 3 },
  { label: 'Recorrências', icon: 'repeat' },
  { label: 'Agenda', icon: 'calendar' },
  { label: 'Dashboard', icon: 'grid' },
];

const ADMIN_ITEMS: NavItem[] = [
  { label: 'Equipa', icon: 'team' },
  { label: 'Serviços', icon: 'tag' },
  { label: 'Configurações', icon: 'settings' },
  { label: 'Plano', icon: 'card' },
];

interface InboxItem {
  avatar: string;
  name: string;
  id: string;
  msg: string;
  time: string;
  active?: boolean;
  unread?: number;
  dot: string;
}

const INBOX: InboxItem[] = [
  { avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop&crop=faces', name: 'Annette Black', id: '#0421', msg: 'Sent a Voice Message', time: '5m', active: true, dot: 'bg-black' },
  { avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&h=120&fit=crop&crop=faces', name: 'Jane Cooper', id: '#9685', msg: 'Very good Quality!', time: '5m', unread: 1, dot: 'bg-black' },
  { avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&h=120&fit=crop&crop=faces', name: 'Samuel Simmons', id: '#9685', msg: 'Very satisfying service', time: '5m', dot: 'bg-orange-400' },
  { avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=120&h=120&fit=crop&crop=faces', name: 'Savannah Nguyen', id: '#9685', msg: 'Very good stuff', time: '5m', dot: 'bg-orange-400' },
  { avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&h=120&fit=crop&crop=faces', name: 'Marvin McKinney', id: '#9685', msg: 'Can I change the shipping address?', time: '5m', dot: 'bg-violet-400' },
  { avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=120&h=120&fit=crop&crop=faces', name: 'Jennie Fisher', id: '#9685', msg: 'Very good stuff', time: '5m', dot: 'bg-blue-400' },
];

interface LastOSItem {
  title: string;
  sub: string;
  id: string;
  highlight?: boolean;
}

const LAST_OS: LastOSItem[] = [
  { title: 'Limpeza pós-obra', sub: 'T3 · Cascais', id: '#0523' },
  { title: 'Manutenção mensal', sub: 'Escritório · Lisboa', id: '#4356', highlight: true },
  { title: 'Janelas + estores', sub: 'Apt T2 · Porto', id: '#5432' },
  { title: 'Lavagem de sofás', sub: 'Vivenda · Sintra', id: '#1243' },
];

const SIDE_ICON_PROPS = {
  width: 14,
  height: 14,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

const SideIcon = ({ name }: { name: string }) => {
  switch (name) {
    case 'chat':
      return <svg {...SIDE_ICON_PROPS}><rect x="3" y="4" width="8" height="7" rx="1.5"/><rect x="13" y="4" width="8" height="7" rx="1.5"/><rect x="3" y="13" width="8" height="7" rx="1.5"/><rect x="13" y="13" width="8" height="7" rx="1.5"/></svg>;
    case 'users':
      return <svg {...SIDE_ICON_PROPS}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
    case 'clipboard':
      return <svg {...SIDE_ICON_PROPS}><rect x="8" y="2" width="8" height="4" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>;
    case 'repeat':
      return <svg {...SIDE_ICON_PROPS}><path d="m17 2 4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/></svg>;
    case 'calendar':
      return <svg {...SIDE_ICON_PROPS}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/></svg>;
    case 'grid':
      return <svg {...SIDE_ICON_PROPS}><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>;
    case 'team':
      return <svg {...SIDE_ICON_PROPS}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>;
    case 'tag':
      return <svg {...SIDE_ICON_PROPS}><path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" x2="7.01" y1="7" y2="7"/></svg>;
    case 'settings':
      return <svg {...SIDE_ICON_PROPS}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09A1.65 1.65 0 0 0 15 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>;
    case 'card':
      return <svg {...SIDE_ICON_PROPS}><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>;
    default:
      return null;
  }
};

const BoxIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="text-black">
    <path d="m7.5 4.27 9 5.15"/>
    <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/>
    <path d="m3.3 7 8.7 5 8.7-5"/>
    <path d="M12 22V12"/>
  </svg>
);

const VOICE_BARS = [3, 5, 7, 4, 6, 8, 5, 3, 6, 7, 4, 5, 8, 6, 3, 5, 7, 4, 6, 5, 7, 4, 5, 6, 3, 5];

export const DashboardMockup = React.memo(() => (
  <div className="w-full bg-gray-50 rounded-2xl shadow-2xl border border-gray-200 overflow-hidden" style={{ aspectRatio: '16/10' }}>
    <div className="flex h-full">
      {/* Sidebar */}
      <aside className="w-[200px] flex-shrink-0 bg-white border-r border-gray-100 p-4 flex flex-col">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center text-[10px] font-bold">OW</div>
            <span className="font-semibold text-gray-900 text-[13px]">OS Works</span>
          </div>
          <div className="w-5 h-5 rounded-md border border-gray-200 flex items-center justify-center text-gray-400">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m15 18-6-6 6-6"/></svg>
          </div>
        </div>

        <div className="text-[9px] font-semibold uppercase tracking-wider text-gray-400 mb-2.5 px-1">Operações</div>
        <nav className="space-y-1 mb-5">
          {NAV_ITEMS.map((item) => (
            <div key={item.label} className={`flex items-center justify-between px-3 py-2 rounded-lg text-[11px] ${item.active ? 'bg-black text-white font-semibold shadow-sm' : 'text-gray-600 hover:bg-gray-50'}`}>
              <div className="flex items-center gap-2.5">
                <SideIcon name={item.icon} />
                <span>{item.label}</span>
              </div>
              {item.badge && <span className="text-[9px] font-bold w-4 h-4 rounded-full bg-red-500 text-white flex items-center justify-center">{item.badge}</span>}
            </div>
          ))}
        </nav>

        <div className="text-[9px] font-semibold uppercase tracking-wider text-gray-400 mb-2.5 px-1">Administração</div>
        <nav className="space-y-1 flex-1">
          {ADMIN_ITEMS.map((item) => (
            <div key={item.label} className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-[11px] text-gray-600 hover:bg-gray-50">
              <SideIcon name={item.icon} />
              <span>{item.label}</span>
            </div>
          ))}
        </nav>

        <div className="border-t border-gray-100 pt-3 mt-2">
          <div className="flex items-center gap-2 px-1 mb-2">
            <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=120&h=120&fit=crop&crop=faces" alt="Maria Silva" className="w-7 h-7 rounded-full object-cover" loading="lazy" />
            <div className="leading-tight">
              <div className="text-[11px] font-semibold text-gray-900">Maria Silva</div>
              <div className="text-[9px] text-gray-500">Administrador</div>
            </div>
          </div>
          <div className="flex items-center gap-2.5 px-3 py-1.5 text-[11px] text-gray-500">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/></svg>
            Sair
          </div>
        </div>
      </aside>

      {/* Main area */}
      <div className="flex-1 flex flex-col bg-gray-50 overflow-hidden">
        {/* Top bar */}
        <div className="flex items-center justify-between px-6 py-4">
          <h1 className="text-lg font-semibold text-gray-900">Chat</h1>
          <div className="flex items-center gap-3">
            <button type="button" className="text-[11px] font-medium px-4 py-2 rounded-full bg-black text-white flex items-center gap-1.5 shadow-sm">
              <span className="text-sm leading-none">+</span> Nova Conversa
            </button>
            <div className="w-8 h-8 rounded-full bg-white border border-gray-100 flex items-center justify-center relative">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="text-gray-600"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>
              <span className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-red-500" />
            </div>
            <div className="flex items-center gap-2 pl-1">
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=120&h=120&fit=crop&crop=faces" alt="Maria Silva" className="w-7 h-7 rounded-full object-cover" loading="lazy" />
              <span className="text-[12px] text-gray-800 font-medium">Maria Silva</span>
            </div>
          </div>
        </div>

        {/* Three columns */}
        <div className="flex-1 grid grid-cols-[240px_1fr_220px] gap-4 px-5 pb-5 overflow-hidden">
          {/* Inbox column */}
          <div className="bg-white rounded-xl flex flex-col overflow-hidden shadow-sm">
            <div className="p-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-gray-900">Inbox</span>
                <span className="text-[9px] text-black font-medium">2 Novos</span>
              </div>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="text-gray-400">
                <circle cx="12" cy="12" r="3"/>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
              </svg>
            </div>
            <div className="px-4 pb-3">
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-50">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-gray-400"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
                <span className="text-[10px] text-gray-400">Buscar mensagem...</span>
              </div>
            </div>
            <div className="flex-1 overflow-hidden px-2 pb-2 space-y-0.5">
              {INBOX.map((c, i) => (
                <div key={i} className={`flex items-start gap-2.5 p-2.5 rounded-lg ${c.active ? 'bg-gray-100' : ''}`}>
                  <div className="relative flex-shrink-0">
                    <img src={c.avatar} alt={c.name} className="w-8 h-8 rounded-full object-cover" loading="lazy" />
                    <span className={`absolute -bottom-0.5 -right-0.5 w-2 h-2 rounded-full border-[1.5px] border-white ${c.dot}`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <span className="text-[11px] font-semibold text-gray-900 truncate">{c.name}</span>
                      <span className="text-[9px] text-gray-400 ml-1">{c.time}</span>
                    </div>
                    <div className="text-[9px] text-gray-400">{c.id}</div>
                    <div className="flex items-center justify-between mt-0.5">
                      <span className="text-[10px] text-gray-500 truncate">{c.msg}</span>
                      {c.unread && <span className="text-[8px] font-bold w-4 h-4 rounded-full bg-black text-white flex items-center justify-center ml-1 flex-shrink-0">{c.unread}</span>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Chat column */}
          <div className="bg-white rounded-xl flex flex-col overflow-hidden shadow-sm">
            <div className="p-4 border-b border-gray-50 flex items-center justify-between">
              <div className="flex items-center gap-2.5">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop&crop=faces" alt="Annette Black" className="w-8 h-8 rounded-full object-cover" loading="lazy" />
                <div className="leading-tight">
                  <div className="text-[12px] font-semibold text-gray-900">Annette Black</div>
                  <div className="text-[9px] text-gray-400">ID: #0421</div>
                </div>
              </div>
              <div className="text-gray-400 text-base leading-none">···</div>
            </div>
            <div className="flex-1 px-4 py-3 space-y-3 overflow-hidden">
              <div className="flex justify-center">
                <span className="text-[9px] text-gray-500 bg-white px-3 py-1 rounded-full border border-gray-100">21 de Agosto</span>
              </div>
              <div className="flex items-end gap-2 max-w-[75%]">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop&crop=faces" alt="Annette" className="w-6 h-6 rounded-full object-cover flex-shrink-0" loading="lazy" />
                <div className="min-w-0">
                  <div className="bg-gray-50 rounded-2xl rounded-bl-md px-3.5 py-2.5 text-[10.5px] text-gray-700 leading-relaxed">
                    Bom dia, ainda há disponibilidade para a limpeza pós-obra esta sexta? Caso sim, gostaria de confirmar para o T3 em Cascais.
                  </div>
                  <div className="text-[9px] text-gray-400 mt-1 ml-1">12:25</div>
                </div>
              </div>
              <div className="flex items-end justify-end">
                <div className="max-w-[75%]">
                  <div className="bg-black text-white rounded-2xl rounded-br-md px-3.5 py-2.5 text-[10.5px] leading-relaxed">
                    Claro, há disponibilidade — a equipa pode começar às 09:00 e está estimada em 5h de serviço para o T3.
                  </div>
                  <div className="text-[9px] text-gray-400 mt-1 text-right mr-1 flex items-center justify-end gap-1">
                    12:32
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-black"><path d="m5 12 5 5L20 7"/></svg>
                  </div>
                </div>
              </div>
              <div className="flex justify-center">
                <span className="text-[9px] text-gray-500 bg-white px-3 py-1 rounded-full border border-gray-100">22 de Agosto</span>
              </div>
              <div className="flex items-end gap-2">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop&crop=faces" alt="Annette" className="w-6 h-6 rounded-full object-cover flex-shrink-0" loading="lazy" />
                <div>
                  <div className="bg-gray-50 rounded-full px-3 py-2 flex items-center gap-2 w-fit">
                    <div className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center flex-shrink-0">
                      <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                    <div className="flex items-center gap-px h-4">
                      {VOICE_BARS.map((h, i) => (
                        <div key={i} className="w-[1.5px] rounded-full bg-black" style={{ height: `${h * 1.5}px` }} />
                      ))}
                    </div>
                    <span className="text-[9px] text-gray-500 ml-1 mr-1">00:38</span>
                  </div>
                  <div className="text-[9px] text-gray-400 mt-1 ml-1">09:00</div>
                </div>
              </div>
            </div>
            <div className="p-3 flex items-center gap-2">
              <div className="flex-1 bg-gray-50 rounded-full px-4 py-2.5 flex items-center justify-between">
                <span className="text-[10.5px] text-gray-400">Escreva uma mensagem...</span>
                <div className="flex items-center gap-2 text-gray-400">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" x2="9.01" y1="9" y2="9"/><line x1="15" x2="15.01" y1="9" y2="9"/></svg>
                </div>
              </div>
              <button type="button" className="w-9 h-9 rounded-full bg-black text-white flex items-center justify-center shadow-sm">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"/></svg>
              </button>
            </div>
          </div>

          {/* Profile column */}
          <div className="bg-white rounded-xl flex flex-col overflow-hidden shadow-sm">
            <div className="p-4 flex items-center justify-between">
              <span className="text-sm font-semibold text-gray-900">Perfil</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-gray-400"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
            </div>
            <div className="flex flex-col items-center pt-2 pb-4 px-3">
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=faces" alt="Annette Black" className="w-16 h-16 rounded-full object-cover mb-3" loading="lazy" />
              <div className="text-[12px] font-semibold text-gray-900">Annette Black</div>
              <div className="text-[9px] text-gray-400 mb-1.5">ID: #0421</div>
              <div className="flex items-center gap-1 text-[10px] text-gray-700">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="#facc15" stroke="#facc15"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                <span className="font-semibold">4.7</span>
                <span className="text-gray-400">(Avaliações)</span>
              </div>
            </div>
            <div className="flex-1 px-4 pb-4 overflow-hidden">
              <div className="flex items-center justify-between mb-2.5">
                <span className="text-[9px] font-semibold uppercase tracking-wider text-gray-400">Últimas OS</span>
                <span className="text-[9px] text-black font-medium">Ver todas</span>
              </div>
              <div className="space-y-2">
                {LAST_OS.map((os) => (
                  <div key={os.id} className={`flex items-center gap-2.5 p-2.5 rounded-lg ${os.highlight ? 'bg-gray-100 ring-1 ring-gray-300' : 'bg-gray-50/60'}`}>
                    <div className="w-7 h-7 rounded-md bg-white flex items-center justify-center flex-shrink-0">
                      <BoxIcon />
                    </div>
                    <div className="flex-1 min-w-0 leading-tight">
                      <div className="text-[10.5px] font-semibold text-gray-900 truncate">{os.title}</div>
                      <div className="text-[9px] text-gray-400">{os.sub}</div>
                    </div>
                    <span className="text-[9px] text-gray-400">{os.id}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
));
DashboardMockup.displayName = 'DashboardMockup';
